module.exports = __webpack_public_path__ + "static/media/games.9b2359f7.png";